import axios from "axios";

export default {
  async create(data) {
    const response = await axios({
      data,
      method: "post",
      url: `/api/address`,
    });
    return response.data.result;
  },
  async get(addressId) {
    const response = await axios({
      method: "get",
      url: `/api/address/${addressId}`,
    });

    return response.data.result;
  },
  async list() {
    const response = await axios({
      method: "get",
      url: `/api/address`,
    });

    return response.data.result;
  },
  async remove(id) {
    await axios({
      method: "delete",
      url: `/api/address/${id}`,
    });
  },
  async update(addressId, data) {
    delete data.addressId;
    delete data.updated;
    delete data.created;
    const attributeList = Object.keys(data);
    attributeList.forEach(attribute => {
      if (data[attribute] === "null") data[attribute] = null;
    });
    const response = await axios({
      data,
      method: "put",
      url: `/api/address/${addressId}`,
    });

    return response.data.result;
  },
};
